export default __webpack_public_path__ + "images/d789217ba559a549ccdfdda31f1ecca3-white-noise.jpeg";